import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { LimitePagamentoEcgPorTerceirosCadastroComponent } from "./cadastro/limite-pagamento-ecg-por-terceiros-cadastro.component";
import { LimitePagamentoEcgPorTerceirosPesquisaComponent } from "./pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa/limite-pagamento-ecg-por-terceiros-pesquisa.component";
import { LimitePagamentoEcgPorTerceirosHistoricoComponent } from "./historico/limite-pagamento-ecg-por-terceiros-historico.component";
import {AuthenticationGuard} from '@bndes/bndes-ux4/bn-seguranca';

const routes: Routes = [
  {
    path: 'limite-pagamento-ecg-por-terceiros',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },

    children: [
      {
        path: '',
        redirectTo: 'pesquisa',
        pathMatch: 'full'

      },
      {
        path: 'pesquisa',
        component: LimitePagamentoEcgPorTerceirosPesquisaComponent
      },
      {
        path: 'cadastro',
        component: LimitePagamentoEcgPorTerceirosCadastroComponent
      },
      {
        path: 'historico',
        component: LimitePagamentoEcgPorTerceirosHistoricoComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class LimitePagamentoEcgPorTerceirosRoutingModule { }
